/**
 * Author: Jack.Hou
 * Date: 2018/8/29
 */

/**
 * 根据给定变量格式化API地址
 *
 * @param url Api地址
 * @param variables 变量集合
 * @returns 格式化后的Api地址
 */
export function formatAPI(url, variables = {}) {
  let result = url
  let keys = Object.keys(variables)
  for (let key of keys) {
    result = result.replace(new RegExp('\\{' + key + '\\}', 'g'), variables[key])
  }
  return result
}

/**
 * 打开一个新的浏览器窗口
 *
 * @param url 地址
 * @param options 可选参数
 * @param callback 回调方法
 */
export function openWindow(url, options = {}, callback) {
  let target = '/'
  if (typeof url === 'string') {
    let prefix = '/'
    if (options.showHeader !== true) {
      prefix += 'direct/'
    }
    target = url.startsWith('/') ? prefix + url.substring(1, url.length) : prefix + url
  }
  let windowName = options.windowName || '_blank'
  let page = window.open('#' + target, windowName)
  if (options.title) {
    page.onload = () => {
      page.document.title = options.title
    }
  }
  if (typeof callback === 'function') {
    let loop = setInterval(() => {
      if (page.closed) {
        clearInterval(loop)
        callback()
      }
    }, 500)
  }
}

/**
 * 引用目录下所有指定格式文件
 *
 * @param r require.context()
 * @example importAll(require.context('src/xxx', false, /\.js$/))
 */
export function importAll(r) {
  return r.keys().map(r)
}

/**
 * 计算窗口高度
 * @param target
 * @param delta
 * @returns {*}
 */
export function calcClientHeight(target, delta) {
  let clientHeight = document.body.clientHeight
  let offetTop = calcAbsoluteTop(target)
  let newHeight = clientHeight - offetTop + delta
  //alert('clientHeight = ' + clientHeight + ', offetTop = ' + offetTop + ', newHeight = ' + newHeight)
  return newHeight
}

function calcAbsoluteTop(target) {
  let parent = target.offsetParent
  if (parent === null) { // 无法获取隐藏元素的坐标相关值
    parent = target.parentElement
    while (parent) {
      if (parent.offsetParent) {
        break
      }
      parent = parent.parentElement
    }
  }
  let loop = 0
  let offetTop = target.offsetTop
  let offetparent = parent
  while (offetparent) {
    offetTop += offetparent.offsetTop
    offetparent = offetparent.offsetParent
    loop++
  }
  return offetTop + loop
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 判断更多条件是否有值
 */
export function changeMoreValue(data) {
  let flag = false
  if (data) {
    data.map(where => {
      if (where.whereMode === 'select' && where.model !== undefined && where.model.length > 0) {
        flag = true
      } else if (where.whereMode !== 'select' && where.model !== undefined && where.model !== null && where.model !== '') {
        flag = true
      }
    })
  }
  return flag
}

/**
 * 清空更多查询条件
 */
export function clearQueryWhere(data) {
  data.map(where => {
    if (where.whereMode === 'select' && where.whereType === 'multi' && where.model !== undefined && where.model.length > 0) {
      where.model = []
    } else if (where.model !== undefined && where.model !== null && where.model !== '') {
      where.model = ''
    }
  })
}

/**
 * 请求预处理
 */
export function prepareRequest(api, reqData) {
  //options
  let options = reqData.options || {}
  //  json
  let json = options.json || false
  if (api && api.json) {
    json = api.json
  }
  options.json = json
  //  download
  let download = options.download || false
  if (api && api.download) {
    download = api.download
  }
  options.download = download
  //  upload
  let upload = options.upload || false
  if (api && api.upload) {
    upload = api.upload
  }
  options.upload = upload
  //url
  let url = reqData.url ? reqData.url : api.url
  if (reqData.urlParams) {
    url = formatAPI(url, reqData.urlParams)
  }
  let request = {}
  request.options = options
  request.url = url
  return request
}
